/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Case type update request containing fields to update.
 * 
 * **Updatable Fields:**
 * - `displayName`: Display name of the case type
 * - `description`: Description of the case type
 * - `defaultSeverity`: Default severity level (CRITICAL, HIGH, MEDIUM, LOW, INFO)
 * - `workflowConfig`: Workflow configuration object
 * - `requiredFields`: Required fields configuration object
 * - `isActive`: Whether the case type is active
 * 
 * **Field-Level Permissions:**
 * - Workflow configuration changes require cases:update:workflow or cases:update:all
 * - Basic updates require cases:update:basic or cases:update:all
 * - Configuration updates require cases:update:configuration or cases:update:all
 * 
 * @export
 * @interface UpdateCaseTypeRequest
 */
export interface UpdateCaseTypeRequest {
    /**
     * Display name of the case type
     * @type {string}
     * @memberof UpdateCaseTypeRequest
     */
    displayName?: string;
    /**
     * Description of the case type
     * @type {string}
     * @memberof UpdateCaseTypeRequest
     */
    description?: string;
    /**
     * Default severity level for this case type
     * @type {string}
     * @memberof UpdateCaseTypeRequest
     */
    defaultSeverity?: UpdateCaseTypeRequestDefaultSeverityEnum;
    /**
     * Workflow configuration for this case type
     * @type {{ [key: string]: any; }}
     * @memberof UpdateCaseTypeRequest
     */
    workflowConfig?: { [key: string]: any; };
    /**
     * Required fields configuration for this case type
     * @type {{ [key: string]: any; }}
     * @memberof UpdateCaseTypeRequest
     */
    requiredFields?: { [key: string]: any; };
    /**
     * Whether the case type is active
     * @type {boolean}
     * @memberof UpdateCaseTypeRequest
     */
    isActive?: boolean;
}


/**
 * @export
 */
export const UpdateCaseTypeRequestDefaultSeverityEnum = {
    Critical: 'CRITICAL',
    High: 'HIGH',
    Medium: 'MEDIUM',
    Low: 'LOW',
    Info: 'INFO'
} as const;
export type UpdateCaseTypeRequestDefaultSeverityEnum = typeof UpdateCaseTypeRequestDefaultSeverityEnum[keyof typeof UpdateCaseTypeRequestDefaultSeverityEnum];


/**
 * Check if a given object implements the UpdateCaseTypeRequest interface.
 */
export function instanceOfUpdateCaseTypeRequest(value: object): value is UpdateCaseTypeRequest {
    return true;
}

export function UpdateCaseTypeRequestFromJSON(json: any): UpdateCaseTypeRequest {
    return UpdateCaseTypeRequestFromJSONTyped(json, false);
}

export function UpdateCaseTypeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCaseTypeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
        'description': json['description'] == null ? undefined : json['description'],
        'defaultSeverity': json['defaultSeverity'] == null ? undefined : json['defaultSeverity'],
        'workflowConfig': json['workflowConfig'] == null ? undefined : json['workflowConfig'],
        'requiredFields': json['requiredFields'] == null ? undefined : json['requiredFields'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
    };
}

export function UpdateCaseTypeRequestToJSON(json: any): UpdateCaseTypeRequest {
    return UpdateCaseTypeRequestToJSONTyped(json, false);
}

export function UpdateCaseTypeRequestToJSONTyped(value?: UpdateCaseTypeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'displayName': value['displayName'],
        'description': value['description'],
        'defaultSeverity': value['defaultSeverity'],
        'workflowConfig': value['workflowConfig'],
        'requiredFields': value['requiredFields'],
        'isActive': value['isActive'],
    };
}

